import { Stack } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { CalculationType, type FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes";
import type { CustomColumnField } from "../../../../../../../../../api/types/svTypes";
import { selectConditions, selectFieldsForCalculation } from "../../../../../store/selectors/fieldsStateSelectors";
import ConditionSelect from "./controls/ConditionSelect";
import { isConditionValueSupported } from "./controls/conditionSelectHelpers";
import ReferenceCalculatedFieldSelect from "./controls/ReferenceCalculatedFIeldSelect";
import TypeOfPredefinedCalculationSelect from "./controls/TypeOfPredefinedCalculationSelect";

interface Props {
  field: CustomColumnField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}
const CustomFieldPredefinedCalculationTypeItem = ({ field, saveChanges, readonly }: Props) => {
  const calculatedFields = useSelector(selectFieldsForCalculation);
  const conditions = useSelector(selectConditions);
  const supportedConditions = useMemo(() => conditions.filter(isConditionValueSupported), [conditions]);

  const handleSelectedFieldGuidChange = (fieldGuid: string) => {
    saveChanges({ formulaParameters: [fieldGuid] }, false);
  };

  const handleSelectedCalculationTypeChange = (calculationType: CalculationType) => {
    saveChanges({ calculationType }, false);
  };

  const isConditionValue = field.config.calculationType === CalculationType.ConditionValue;

  return (
    <Stack spacing={2} sx={{ py: 1.5, px: 2 }}>
      {field.config.calculationType && (
        <TypeOfPredefinedCalculationSelect
          selectedCalculationType={field.config.calculationType}
          onSelectedCalculationTypeChange={handleSelectedCalculationTypeChange}
          readonly={readonly}
        />
      )}
      {!isConditionValue && field.config.formulaParameters?.[0] && (
        <ReferenceCalculatedFieldSelect
          selectedFieldGuid={field.config.formulaParameters?.[0]}
          onSelectedFieldGuidChange={handleSelectedFieldGuidChange}
          calculatedFields={calculatedFields}
          selectedFieldGuidError={undefined}
          readonly={readonly}
        />
      )}
      {isConditionValue && (
        <ConditionSelect
          selectedConditionGuid={field.config.formulaParameters?.[0]}
          onSelectedConditionGuidChange={handleSelectedFieldGuidChange}
          conditions={supportedConditions}
          selectedConditionGuidError={undefined}
          readonly={readonly}
        />
      )}
    </Stack>
  );
};

export default CustomFieldPredefinedCalculationTypeItem;
